import AjaxForm, { EVENT_ERROR, EVENT_SUCCESS } from "webPage/AjaxForm";
import Ajax from "base/Ajax";
import RecaptchaHelper from "util/RecaptchaHelper.js";

export default class GravityForm {
    constructor($element) {
        this.$element = $element;
        this.$form = this.$element.find('.js-form');
        this.formid = this.$element.data('formid');

        this.bindEvents();
    }

    bindEvents() {
        this.attachForm();
    }

    show() {
        RecaptchaHelper.init(this.$element);
        this.form.validator.updateInputs();
    }

    attachForm() {
        this.form = new AjaxForm(this.$form, async ($form, formData) => {

            const response = await Ajax.post('eotw-gravity-forms', 'entries', formData);

            if (response.status !== 'success') {
                throw response;
            }

            return response;
        });

        this.form.on(EVENT_SUCCESS, (data) => {
            this.$form.remove();
            this.$element.append(eotwJSXFactory('div', {unsafeHtml: data.data['confirmation_message']}));
        }).on(EVENT_ERROR, (e) => {
            console.trace('error', e);
            this.$form.find('button[type="submit"]').removeClass('btn--loading');
            this.form.showError(e);

            $('html, body').animate({
                scrollTop: (this.form.getErrorContainer().offset().top - 250),
            }, 500);
        });
    }
}
